import axios from 'axios'
import { DashboardSummaryDto, DashboardFilterParams } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const getDashboardSummary = async (params?: DashboardFilterParams): Promise<DashboardSummaryDto> => {
  const response = await axios.get<{ success?: boolean; data: DashboardSummaryDto }>(
    `${API_URL}/call/dashboard/summary`,
    { params }
  )
  return response.data.data
}
